
import { useWizard } from "./FormWizardContext";

export const StepDescription = () => {
  const { currentStep, totalSteps } = useWizard();

  const getStepTitle = () => {
    // If we're in a 2-step process (Phase 3+), step 1 is Invoice Generation
    if (totalSteps === 2) {
      return currentStep === 1 ? "Invoice Generation" : "Review Your Information";
    }
    
    // Default step titles for other phases
    switch (currentStep) {
      case 1:
        return "Creator Information";
      case 2:
        return "Content Information";
      case 3:
        return "Additional Information";
      case 4:
        return "Invoice Generation";
      case 5:
        return "Review Your Information";
      default:
        return "";
    }
  };

  const getStepDescription = () => {
    // If we're in a 2-step process (Phase 3+), step 1 is Invoice Generation
    if (totalSteps === 2) {
      return currentStep === 1 
        ? "Generate a payment invoice for your content creation."
        : "Review all information before submitting.";
    }
    
    // Default step descriptions for other phases
    switch (currentStep) {
      case 1:
        return "Please provide your basic creator information.";
      case 2:
        return "Please share details about your social media presence and content.";
      case 3:
        return "Tell us more about your region, content links, and feedback.";
      case 4:
        return "Generate a payment invoice for your content creation.";
      case 5:
        return "Review all information before submitting.";
      default:
        return "";
    }
  };

  return (
    <div className="text-center space-y-1.5 mb-6">
      <h3 className="text-lg font-medium text-gray-800 dark:text-white">
        {getStepTitle()}
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        {getStepDescription()}
      </p>
    </div>
  );
};
